"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
require("./IconSvg.scss");
var React = require("react");
var IconSvg = /** @class */ (function (_super) {
    __extends(IconSvg, _super);
    function IconSvg(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidMount = function () {
            var svgUrl = _this.props.svgUrl;
            if (svgUrl) {
                _this.getIconFromUrl();
            }
        };
        _this.getIconFromUrl = function () { return __awaiter(_this, void 0, void 0, function () {
            var svgUrl, response, svgMarkUp, svgContent, viewBoxVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        svgUrl = this.props.svgUrl;
                        return [4 /*yield*/, fetch(svgUrl)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.text()];
                    case 2:
                        svgMarkUp = _a.sent();
                        svgContent = this.getIconContent(svgMarkUp);
                        viewBoxVal = this.getViewBoxVal(svgMarkUp);
                        this.setState({ svgContent: svgContent, viewBoxVal: viewBoxVal });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.renderIconFromStr = function () {
            var svgNodeStr = _this.props.svgNodeStr;
            if (svgNodeStr) {
                var svgContent = _this.getIconContent(svgNodeStr);
                var viewBoxVal = _this.getViewBoxVal(svgNodeStr);
                return _this.renderSvg(svgContent, viewBoxVal);
            }
            return null;
        };
        _this.getIconContent = function (svgNode) {
            var trimmedStr = svgNode.trim();
            var index = trimmedStr.indexOf("><");
            var returnStr = trimmedStr.substring(index + 1, trimmedStr.length - 6);
            return returnStr;
        };
        _this.getViewBoxVal = function (svgFromSource) {
            var splitA = svgFromSource.split('viewBox="');
            var splitB = splitA[1].split('"');
            var viewBoxVal = splitB[0];
            return viewBoxVal;
        };
        _this.renderSvg = function (svgContent, viewBoxVal) {
            var _a = _this.props, ariaHidden = _a.ariaHidden, ariaLabel = _a.ariaLabel, className = _a.className, colorClass = _a.colorClass, pictogramAccent = _a.pictogramAccent, pictogramDarkBg = _a.pictogramDarkBg, size = _a.size;
            var iconClass = colorClass;
            if (pictogramAccent) {
                iconClass = "svg-accent-att-blue " + (pictogramDarkBg ? "color-ui-white" : "color-black");
            }
            return (React.createElement("svg", { "aria-hidden": ariaHidden !== false, "aria-label": ariaHidden !== false ? undefined : ariaLabel, className: "inline-block " + iconClass + (className ? " " + className : ""), focusable: !(ariaHidden !== false), role: ariaHidden !== false ? undefined : "img", height: size ? size + "px" : undefined, width: size ? size + "px" : undefined, viewBox: viewBoxVal, dangerouslySetInnerHTML: {
                    __html: svgContent,
                } }));
        };
        _this.render = function () {
            var _a = _this.props, svgNodeStr = _a.svgNodeStr, svgUrl = _a.svgUrl;
            if (svgUrl) {
                var _b = _this.state, svgContent = _b.svgContent, viewBoxVal = _b.viewBoxVal;
                if (svgContent && viewBoxVal) {
                    return _this.renderSvg(svgContent, viewBoxVal);
                }
            }
            else if (svgNodeStr && svgNodeStr.trim().substring(1, 4) === "svg") {
                return _this.renderIconFromStr();
            }
            return null;
        };
        _this.state = {
            svgContent: null,
            viewBoxVal: null,
        };
        return _this;
    }
    return IconSvg;
}(React.PureComponent));
exports.default = IconSvg;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/IconSvg/IconSvg.js
// module id = 1660
// module chunks = 8